import { apiFetch } from "../utils/apiClient";
import { scenarioBlockReason } from "../utils/connectionHealth";
// import React, { useEffect, useState } from "react";
// import { Mail, Clock, Server, Layers, Trash2, X, Workflow } from "lucide-react";
// import { useNavigate } from "react-router-dom";
// import Sidebar from "../component/Sidebar";
// import ScenarioSelectModal from "../component/ScenarioSelectModal";

// const getScenarioName = (scenario) => {
//   if (scenario.name && scenario.name.trim() !== "") return scenario.name;
//   const modules = scenario.routerBranches?.[0]?.modules || [];
//   if (
//     modules.some((m) => m.type === "Send an Email" && m.app?.name === "Gmail")
//   )
//     return "Gmail Scenario";
//   if (modules.some((m) => m.type === "Custom Email"))
//     return "Outlook/SMTP Scenario";
//   if (modules.some((m) => m.type === "Delay")) return "Delay Scenario";
//   if (modules.length > 1) return "Mixed Scenario";
//   return "Untitled Scenario";
// };

// const getScenarioDescription = (scenario) => {
//   if (scenario.description && scenario.description.trim() !== "")
//     return scenario.description;
//   const modules = scenario.routerBranches?.[0]?.modules || [];
//   if (modules.length > 0) return modules.map((m) => m.description).join(", ");
//   return "No description available";
// };

// const getScenarioIcon = (scenario) => {
//   const modules = scenario.routerBranches?.[0]?.modules || [];
//   if (modules.some((m) => m.app?.name === "Gmail"))
//     return <Mail className="w-5 h-5 text-red-500" />;
//   if (modules.some((m) => m.type === "Custom Email"))
//     return <Server className="w-5 h-5 text-blue-500" />;
//   if (modules.some((m) => m.type === "Delay"))
//     return <Clock className="w-5 h-5 text-yellow-500" />;
//   return <Layers className="w-5 h-5 text-purple-500" />;
// };

// const Loader = () => (
//   <tr>
//     <td colSpan="5">
//       <div className="flex flex-col justify-center items-center py-10">
//         <svg
//           className="animate-spin h-8 w-8 text-purple-600 mb-2"
//           viewBox="0 0 24 24"
//         >
//           <circle
//             className="opacity-25"
//             cx="12"
//             cy="12"
//             r="10"
//             stroke="currentColor"
//             strokeWidth="4"
//           ></circle>
//           <path
//             className="opacity-75"
//             fill="currentColor"
//             d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//           ></path>
//         </svg>
//         <p className="text-sm text-purple-600 font-medium">Loading data...</p>
//       </div>
//     </td>
//   </tr>
// );

// const AllScenariosPage = () => {
//   const [scenarios, setScenarios] = useState([]);
//   const [deleteModalOpen, setDeleteModalOpen] = useState(false);
//   const [selectedScenario, setSelectedScenario] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [openScenarioModal, setOpenScenarioModal] = useState(false);
//   const [upgradeModalOpen, setUpgradeModalOpen] = useState(false);
//   const navigate = useNavigate();

//   useEffect(() => {
//     fetchScenarios();
//   }, []);

//   const fetchScenarios = async () => {
//     const userId = localStorage.getItem("userid");
//     try {
//       setLoading(true);
//       const res = await apiFetch(`https://email-syncing-backend.onrender.com/scenario/user/${userId}`);
//       const data = await res.json();
//       setScenarios(Array.isArray(data) ? data : data.data || []);
//     } catch (err) {
//       console.error("Error fetching scenarios:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleRowClick = (scenario) => {
//     navigate(
//       scenario.type === "shopify"
//         ? `/scenarios/shopify/${scenario._id}`
//         : `/scenarios/others/${scenario._id}`,
//     );
//   };

//   const handleDelete = async () => {
//     if (!selectedScenario) return;
//     try {
//       await apiFetch(
//         `https://email-syncing-backend.onrender.com/scenario/detail/${selectedScenario._id}`,
//         { method: "DELETE" },
//       );
//       setDeleteModalOpen(false);
//       setSelectedScenario(null);
//       fetchScenarios();
//     } catch (err) {
//       console.error("Error deleting scenario:", err);
//     }
//   };

//   const handleSelectScenario = (type) => {
//     setOpenScenarioModal(false);
//     navigate(type === "shopify" ? "/scenarios/shopify" : "/scenarios/others");
//   };

//   return (
//     <div className="flex bg-gradient-to-br from-gray-50 to-indigo-50 min-h-screen font-inter">
//       <Sidebar />

//       <main className="flex-1  flex flex-col">
//         <header className="flex flex-col md:flex-row md:items-center justify-between px-4 py-1 bg-white border-b border-gray-100 shadow-sm gap-4">
//           <div className="flex items-center gap-4">
//             <div className="hidden sm:flex w-12 h-12 bg-indigo-50 rounded-xl items-center justify-center text-indigo-600">
//               <Workflow className="w-6 h-6" />
//             </div>

//             <div>
//               <h1 className="text-2xl font-bold text-gray-900 tracking-tight">
//                 All Scenarios
//               </h1>
//               <p className="text-sm text-gray-500 mt-0.5">
//                 Manage, edit, and organize your automation workflows.
//               </p>
//             </div>
//           </div>

//           <div className="flex flex-wrap items-center gap-3 bg-gray-50 p-1.5 rounded-2xl border border-gray-100">
//             <div className="text-sm text-gray-600 font-medium px-3 py-1 bg-white rounded-lg border border-gray-100 shadow-sm">
//               Shopify:{" "}
//               <span className="font-semibold text-indigo-600">
//                 {scenarios.filter((s) => s.type === "shopify").length}/1
//               </span>
//             </div>

//             <div className="text-sm text-gray-600 font-medium px-3 py-1 bg-white rounded-lg border border-gray-100 shadow-sm">
//               Custom:{" "}
//               <span className="font-semibold text-indigo-600">
//                 {scenarios.filter((s) => s.type !== "shopify").length}/2
//               </span>
//             </div>

//             <button
//               onClick={() => {
//                 const shopifyCount = scenarios.filter(
//                   (s) => s.type === "shopify",
//                 ).length;
//                 const customCount = scenarios.filter(
//                   (s) => s.type !== "shopify",
//                 ).length;

//                 if (shopifyCount >= 1 && customCount >= 2) {
//                   setUpgradeModalOpen(true);
//                   return;
//                 }

//                 setOpenScenarioModal(true);
//               }}
//               className="px-4 py-2 rounded-xl font-medium shadow-sm bg-indigo-600 hover:bg-indigo-500 text-white transition"
//             >
//               + New Scenario
//             </button>
//           </div>
//         </header>

//         {/* 🔹 Responsive Table */}
//         <section className="flex-1 p-4 sm:p-6 lg:p-8 overflow-x-auto">
//           {/* 📱 Responsive Scenarios List */}
//           <div className="bg-white rounded-2xl shadow-sm border border-gray-200">
//             {/* 🖥️ Table for md+ screens */}
//             <table className="hidden md:table w-full text-sm text-left text-gray-600">
//               <thead className="bg-gray-100 text-gray-700 uppercase tracking-wide text-xs">
//                 <tr>
//                   <th className="px-6 py-3">Scenario</th>
//                   <th className="px-6 py-3">Description</th>
//                   <th className="px-6 py-3">Type</th>
//                   <th className="px-6 py-3">Created</th>
//                   <th className="px-6 py-3 text-right">Actions</th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-gray-100">
//                 {scenarios.map((scenario) => (
//                   <tr
//                     key={scenario._id}
//                     onClick={() => handleRowClick(scenario)}
//                     className="hover:bg-indigo-50 cursor-pointer"
//                   >
//                     <td className="px-6 py-4 flex items-center gap-3 font-semibold text-gray-800">
//                       <div className="flex items-center justify-center w-9 h-9 rounded-lg bg-indigo-100 text-indigo-600">
//                         {getScenarioIcon(scenario)}
//                       </div>
//                       {getScenarioName(scenario)}
//                     </td>
//                     <td className="px-6 py-4 text-gray-600 truncate max-w-sm">
//                       {getScenarioDescription(scenario)}
//                     </td>
//                     <td className="px-6 py-4 capitalize">{scenario.type}</td>
//                     <td className="px-6 py-4 text-gray-500">
//                       {new Date(scenario.createdAt).toLocaleDateString(
//                         "en-US",
//                         {
//                           year: "numeric",
//                           month: "short",
//                           day: "numeric",
//                         },
//                       )}
//                     </td>
//                     <td className="px-6 py-4 text-right">
//                       <button
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           setSelectedScenario(scenario);
//                           setDeleteModalOpen(true);
//                         }}
//                         className="text-gray-400 hover:text-red-500"
//                       >
//                         <Trash2 className="w-5 h-5" />
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>

//             {/* 📱 Mobile Card View */}
//             <div className="md:hidden divide-y divide-gray-100">
//               {scenarios.map((scenario) => (
//                 <div
//                   key={scenario._id}
//                   onClick={() => handleRowClick(scenario)}
//                   className="p-4 hover:bg-indigo-50 transition cursor-pointer"
//                 >
//                   <div className="flex items-center gap-3 mb-2">
//                     <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-indigo-100 text-indigo-600">
//                       {getScenarioIcon(scenario)}
//                     </div>
//                     <div className="flex-1">
//                       <h3 className="text-base font-semibold text-gray-900">
//                         {getScenarioName(scenario)}
//                       </h3>
//                       <p className="text-xs text-gray-500">
//                         {new Date(scenario.createdAt).toLocaleDateString(
//                           "en-US",
//                           {
//                             month: "short",
//                             day: "numeric",
//                           },
//                         )}{" "}
//                         • {scenario.type}
//                       </p>
//                     </div>
//                     <button
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         setSelectedScenario(scenario);
//                         setDeleteModalOpen(true);
//                       }}
//                       className="text-gray-400 hover:text-red-500"
//                     >
//                       <Trash2 className="w-5 h-5" />
//                     </button>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </section>
//       </main>

//       {/* 🗑️ Delete Modal */}
//       {deleteModalOpen && (
//         <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 px-4">
//           <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm sm:max-w-md p-6">
//             <div className="flex justify-between items-center mb-4">
//               <h2 className="text-lg font-semibold text-gray-900">
//                 Confirm Delete
//               </h2>
//               <button
//                 onClick={() => setDeleteModalOpen(false)}
//                 className="text-gray-400 hover:text-gray-600 transition"
//               >
//                 <X className="w-5 h-5" />
//               </button>
//             </div>

//             <p className="text-gray-600 mb-6 leading-relaxed">
//               Are you sure you want to delete{" "}
//               <span className="font-semibold text-gray-800">
//                 {selectedScenario?.name || "this scenario"}
//               </span>
//               ?
//             </p>

//             <div className="flex justify-end gap-3">
//               <button
//                 onClick={() => setDeleteModalOpen(false)}
//                 className="px-4 py-2 rounded-lg bg-gray-100 hover:bg-gray-200 text-gray-700 transition"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleDelete}
//                 className="px-4 py-2 rounded-lg bg-red-600 hover:bg-red-700 text-white shadow transition"
//               >
//                 Delete
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {upgradeModalOpen && (
//         <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 px-4">
//           <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-6 relative">
//             <button
//               onClick={() => setUpgradeModalOpen(false)}
//               className="absolute right-4 top-4 text-gray-400 hover:text-gray-600 transition"
//             >
//               <X className="w-5 h-5" />
//             </button>

//             <div className="w-12 h-12 rounded-xl bg-indigo-100 text-indigo-600 flex items-center justify-center mb-4">
//               <Layers className="w-6 h-6" />
//             </div>

//             <h2 className="text-xl font-bold text-gray-900 mb-2">
//               Scenario Limit Reached
//             </h2>

//             <p className="text-gray-600 leading-relaxed mb-5">
//               You’ve reached the free plan limit of{" "}
//               <span className="font-semibold text-gray-900">
//                 1 Shopify scenario
//               </span>{" "}
//               and{" "}
//               <span className="font-semibold text-gray-900">
//                 2 custom scenarios
//               </span>
//               . Higher limits will be available with the Pro plan soon.
//             </p>

//             <div className="rounded-xl border border-indigo-100 bg-indigo-50 px-4 py-3 mb-5">
//               <p className="text-sm font-semibold text-indigo-700">
//                 Pro plan coming soon
//               </p>
//               <p className="text-sm text-indigo-600 mt-1">
//                 More scenarios, higher automation limits, and advanced workflow
//                 features are on the way.
//               </p>
//             </div>

//             <div className="flex justify-end">
//               <button
//                 onClick={() => setUpgradeModalOpen(false)}
//                 className="px-4 py-2 rounded-lg bg-indigo-600 hover:bg-indigo-700 text-white font-medium shadow transition"
//               >
//                 Got it
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ✅ Scenario Select Modal */}
//       <ScenarioSelectModal
//         open={openScenarioModal}
//         onClose={() => setOpenScenarioModal(false)}
//         onSelect={handleSelectScenario}
//       />
//     </div>
//   );
// };

// export default AllScenariosPage;
import React, { useEffect, useState, useRef, useContext } from "react";
import {
  Mail,
  Clock,
  Server,
  Layers,
  Trash2,
  X,
  Workflow,
  Plus,
  Search,
  ChevronRight,
  AlertTriangle,
  PlayCircle,
  PauseCircle,
  Sparkles,
  SlidersHorizontal,
  Check,
  Cpu,
  ChevronDown,
  ChevronUp,
  Zap,
  Settings,
  Lock,
} from "lucide-react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import AppLayout from "../component/AppLayout";
import { UserContext } from "../component/UserContext";
import StatusDot from "../component/StatusDot";
import ScenarioSelectModal from "../component/ScenarioSelectModal";
import { getCached, setCached, getCacheKey, invalidateCache } from "../utils/appCache";
import { TableSkeleton } from "../component/Skeletons";

const getScenarioName = (scenario) => {
  if (scenario.name?.trim()) {
    return scenario.name;
  }

  const modules = scenario.routerBranches?.[0]?.modules || [];

  if (
    modules.some(
      (module) =>
        module.type === "Send an Email" &&
        module.app?.name === "Gmail",
    )
  ) {
    return "Gmail Scenario";
  }

  if (modules.some((module) => module.type === "Custom Email")) {
    return "Outlook / SMTP Scenario";
  }

  if (modules.some((module) => module.type === "Delay")) {
    return "Delay Scenario";
  }

  if (modules.length > 1) {
    return "Mixed Workflow";
  }

  return "Untitled Scenario";
};

const getScenarioDescription = (scenario) => {
  if (scenario.description?.trim()) {
    return scenario.description;
  }

  const modules = scenario.routerBranches?.[0]?.modules || [];

  if (modules.length > 0) {
    return modules
      .map((module) => module.description)
      .filter(Boolean)
      .join(", ");
  }

  return "No description configured for this scenario.";
};

const getScenarioIcon = (scenario) => {
  const modules = scenario.routerBranches?.[0]?.modules || [];

  if (modules.some((module) => module.app?.name === "Gmail")) {
    return <Mail className="h-4 w-4 text-zinc-900" />;
  }

  if (modules.some((module) => module.type === "Custom Email")) {
    return <Server className="h-4 w-4 text-zinc-800" />;
  }

  if (modules.some((module) => module.type === "Delay")) {
    return <Clock className="h-4 w-4 text-zinc-700" />;
  }

  return <Layers className="h-4 w-4 text-zinc-700" />;
};

const formatDate = (date) => {
  if (!date) return "N/A";

  return new Date(date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

const isScenarioConfigured = (scenario) => {
  if (!scenario) return false;

  // 1. Check incoming lead trigger connection / mailhook
  const incoming = scenario.incomingLead;
  const isMailhook = (incoming?.app?.name || "").toLowerCase() === "mailhook";
  const hasTrigger = isMailhook
    ? Boolean(incoming?.mailhookId)
    : Boolean(incoming?.connectionId);

  if (!hasTrigger) return false;

  // 2. Check router branch modules
  const branches = scenario.routerBranches || [];
  if (!Array.isArray(branches) || branches.length === 0) return false;

  const modules = branches.flatMap((b) => b.modules || []);
  if (modules.length === 0) return false;

  // Check that all email modules have a connectionId
  const emailModules = modules.filter((m) => {
    const isDelay =
      m.type === "Delay" ||
      m.app?.name?.toLowerCase() === "delay" ||
      Boolean(m.delayValue);
    return !isDelay;
  });

  if (emailModules.length === 0) return false;

  const allEmailModulesConfigured = emailModules.every(
    (m) =>
      Boolean(m.connectionId) ||
      (m.replyMode === "ai" && Boolean(m.companyProfileId))
  );

  return allEmailModulesConfigured;
};

const AllScenariosPage = () => {
  const navigate = useNavigate();

  const userId = localStorage.getItem("userid");
  const cachedScenarios = getCached(getCacheKey("scenarios_list", userId));

  const [scenarios, setScenarios] = useState(cachedScenarios || []);
  const [selectedScenario, setSelectedScenario] = useState(null);

  const [loading, setLoading] = useState(!cachedScenarios);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [upgradeModalOpen, setUpgradeModalOpen] = useState(false);
  const [showSelectModal, setShowSelectModal] = useState(false);

  // New Split Dropdown State & Ref
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const [searchQuery, setSearchQuery] = useState("");
  const [activeFilter, setActiveFilter] = useState("all");

  // Close dropdown on click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const fetchScenarios = async (isBackground = false) => {
    const currentUserId = localStorage.getItem("userid") || userId;

    if (!currentUserId) {
      return;
    }

    try {
      if (!isBackground && scenarios.length === 0) {
        setLoading(true);
      }
      const token = localStorage.getItem("usertoken");

      const response = await apiFetch(
        `https://email-syncing-backend.onrender.com/scenario/user/${currentUserId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await response.json();

      if (response.ok) {
        const list = Array.isArray(data) ? data : data.data || [];
        setScenarios(list);
        setCached(getCacheKey("scenarios_list", currentUserId), list);
      } else {
        console.error("Failed to fetch scenarios:", data.message);
      }
    } catch (error) {
      console.error("Error fetching scenarios:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchScenarios(Boolean(cachedScenarios));
  }, []);

  /*
   * The mailboxes behind these scenarios.
   *
   * A paused row said "Paused" and nothing else, so a scenario switched
   * off deliberately and one the server refuses to run looked identical.
   * The difference is entirely in the connections, so they are loaded here
   * to name the reason on the row.
   */
  const [connections, setConnections] = useState([]);

  useEffect(() => {
    let cancelled = false;

    const loadConnections = async () => {
      const currentUserId = localStorage.getItem("userid") || userId;
      if (!currentUserId) return;

      try {
        const res = await apiFetch(`/auth/getConnection/${currentUserId}`);
        const data = await res.json();
        const list = Array.isArray(data) ? data : data?.data || [];

        if (!cancelled) setConnections(list);
      } catch (error) {
        /* The list still renders; rows just cannot explain themselves. */
        console.error("Error fetching connections:", error);
      }
    };

    loadConnections();

    return () => {
      cancelled = true;
    };
  }, [userId]);

  const { user } = useContext(UserContext);
  const userPlan = user?.subscription?.plan || "Explore";

  const activeCount = scenarios.filter((s) => s.scenarioActive).length;
  const pausedCount = scenarios.filter((s) => !s.scenarioActive).length;
  const shopifyCount = scenarios.filter((s) => s.type === "shopify").length;
  const customCount = scenarios.filter((s) => s.type !== "shopify").length;

  const filteredScenarios = scenarios.filter((scenario) => {
    const name = getScenarioName(scenario).toLowerCase();
    const description = getScenarioDescription(scenario).toLowerCase();
    const query = searchQuery.toLowerCase().trim();

    const matchesSearch =
      name.includes(query) || description.includes(query);

    const matchesFilter =
      activeFilter === "all" ||
      (activeFilter === "shopify" && scenario.type === "shopify") ||
      (activeFilter === "custom" && scenario.type !== "shopify") ||
      (activeFilter === "active" && scenario.scenarioActive) ||
      (activeFilter === "paused" && !scenario.scenarioActive);

    return matchesSearch && matchesFilter;
  });

  const handleRowClick = (scenario) => {
    navigate(
      scenario.type === "shopify"
        ? `/scenarios/shopify/${scenario._id}`
        : `/scenarios/others/${scenario._id}`,
    );
  };

  const getPlanActiveLimit = (plan) => {
    const p = (plan || "").toLowerCase();
    if (p === "elevate") return 5;
    if (p === "unite") return 15;
    if (p === "enterprise") return 999;
    return 1;
  };

  const planActiveLimit = getPlanActiveLimit(userPlan);

  const handleToggleScenarioStatus = async (event, scenario) => {
    event.stopPropagation();
    const willBeActive = !scenario.scenarioActive;

    if (willBeActive) {
      if (activeCount >= planActiveLimit) {
        setSelectedScenario(scenario);
        setUpgradeModalOpen(true);
        return;
      }

      if (!isScenarioConfigured(scenario)) {
        toast.error(
          "Please complete your scenario configuration first before activating.",
          { duration: 4500 }
        );
        if (scenario.type === "shopify") {
          navigate(`/scenarios/shopify/${scenario._id}`);
        } else {
          navigate(`/scenarios/others/${scenario._id}`);
        }
        return;
      }
    }

    try {
      const token = localStorage.getItem("usertoken");
      const res = await apiFetch(
        `https://email-syncing-backend.onrender.com/scenario/detail/${scenario._id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            ...scenario,
            scenarioActive: willBeActive,
          }),
        }
      );
      const data = await res.json();

      if (willBeActive && data.scenarioActive === false) {
        /*
         * The server now says WHICH step it objected to. An expired
         * mailbox sign-in is the usual answer, and "complete your
         * configuration" sent people looking for a setting that was
         * already filled in.
         */
        toast.error(
          data?.blockers?.[0]?.message ||
            "Please complete your scenario configuration first before activating.",
          { duration: 6000 }
        );
        if (scenario.type === "shopify") {
          navigate(`/scenarios/shopify/${scenario._id}`);
        } else {
          navigate(`/scenarios/others/${scenario._id}`);
        }
        return;
      }

      const updatedList = scenarios.map((s) =>
        s._id === scenario._id ? { ...s, scenarioActive: willBeActive } : s
      );
      setScenarios(updatedList);
      setCached(getCacheKey("scenarios_list", userId), updatedList);
      setCached(getCacheKey("dashboard_scenarios", userId), updatedList);
      window.dispatchEvent(
        new CustomEvent("scenarioStatusChanged", {
          detail: { scenarioId: scenario._id, scenarioActive: willBeActive },
        })
      );

      toast.success(
        willBeActive
          ? `Scenario "${getScenarioName(scenario)}" activated!`
          : `Scenario "${getScenarioName(scenario)}" paused.`
      );
      invalidateCache("scenarios");
      invalidateCache("dashboard");
      fetchScenarios(true);
    } catch (err) {
      console.error("Error toggling scenario active status:", err);
      toast.error("Failed to update scenario status.");
    }
  };

  const handleCreateScenario = (type) => {
    setDropdownOpen(false);
    if (type === "shopify") {
      if (userPlan.toLowerCase() === "explore" && shopifyCount >= 1) {
        setUpgradeModalOpen(true);
        return;
      }
      navigate(userPlan.toLowerCase() !== "explore" ? "/scenarios/shopify/new" : "/scenarios/shopify");
    } else {
      navigate("/scenarios/others");
    }
  };

  const handleDelete = async () => {
    if (!selectedScenario) return;

    try {
      const token = localStorage.getItem("usertoken");
      await apiFetch(
        `https://email-syncing-backend.onrender.com/scenario/detail/${selectedScenario._id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setDeleteModalOpen(false);
      setSelectedScenario(null);

      invalidateCache("scenarios");
      invalidateCache("dashboard");
      fetchScenarios(true);
    } catch (error) {
      console.error("Error deleting scenario:", error);
    }
  };

  const openDeleteModal = (event, scenario) => {
    event.stopPropagation();

    if (scenario?.type === "shopify" && shopifyCount <= 1) {
      toast.error("The primary Shopify prebuilt scenario cannot be deleted.");
      return;
    }

    setSelectedScenario(scenario);
    setDeleteModalOpen(true);
  };

  const filterOptions = [
    { label: "All Workflows", value: "all", count: scenarios.length },
    { label: "Shopify", value: "shopify", count: shopifyCount },
    { label: "Custom", value: "custom", count: customCount },
    { label: "Active", value: "active", count: activeCount },
    { label: "Paused", value: "paused", count: pausedCount },
  ];

  return (
    <AppLayout>
      <div className="flex-1 overflow-y-auto px-6 py-3 bg-zinc-100 font-sans text-zinc-900">
        {/* Full-width container */}
        <div className="w-full ">
          {/* Header */}
          <div className="mb-8 flex flex-col justify-between gap-4 sm:flex-row sm:items-center">
            <div>
              <div className="flex items-center gap-2.5">
                <div className="flex h-9 w-9 items-center justify-center rounded-[8px] bg-zinc-900 text-white shadow-xs">
                  <Workflow className="h-5 w-5" />
                </div>
                <h1 className="text-2xl font-bold tracking-tight text-zinc-900">
                  Scenarios
                </h1>
              </div>
              <p className="mt-1 text-sm text-zinc-500">
                Manage, edit and organize your automated workflows.
              </p>
            </div>
          </div>

          {/* Metric Cards Grid */}
          <section className="mb-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            <div className="rounded-[8px] border border-zinc-200 bg-white p-5 shadow-xs transition hover:border-zinc-300">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-[11px] font-semibold uppercase  text-zinc-500">
                    Total Scenarios
                  </p>
                  <p className="mt-2 text-2xl font-bold text-zinc-900">
                    {scenarios.length}
                  </p>
                </div>
                <div className="flex h-10 w-10 items-center justify-center rounded-[8px] bg-zinc-100 text-zinc-700">
                  <Layers className="h-5 w-5" />
                </div>
              </div>
            </div>

            <div className="rounded-[8px] border border-zinc-200 bg-white p-5 shadow-xs transition hover:border-zinc-300">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-[11px] font-semibold uppercase  text-zinc-500">
                    Shopify Scenarios
                  </p>
                  <div className="mt-2 flex items-baseline gap-1">
                    <span className="text-2xl font-bold text-zinc-900">
                      {shopifyCount}
                    </span>
                    <span className="text-xs font-medium text-zinc-400">
                      {userPlan.toLowerCase() === "explore" ? "/ 1 (Free)" : "total"}
                    </span>
                  </div>
                </div>
                <div className="flex h-10 w-10 items-center justify-center rounded-[8px] bg-zinc-100 text-zinc-700">
                  <Mail className="h-5 w-5" />
                </div>
              </div>
            </div>

            <div className="rounded-[8px] border border-zinc-200 bg-white p-5 shadow-xs transition hover:border-zinc-300">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-[11px] font-semibold uppercase  text-zinc-500">
                    Custom Workflows
                  </p>
                  <div className="mt-2 flex items-baseline gap-1">
                    <span className="text-2xl font-bold text-zinc-900">
                      {customCount}
                    </span>
                    <span className="text-xs font-semibold text-emerald-600">
                      (Unlimited)
                    </span>
                  </div>
                </div>
                <div className="flex h-10 w-10 items-center justify-center rounded-[8px] bg-zinc-100 text-zinc-700">
                  <Cpu className="h-5 w-5" />
                </div>
              </div>
            </div>

            <div className="rounded-[8px] border border-zinc-200 bg-white p-5 shadow-xs transition hover:border-zinc-300">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-[11px] font-semibold uppercase  text-zinc-500">
                    Active Automations
                  </p>
                  <div className="mt-2 flex items-baseline gap-1">
                    <span className="text-2xl font-bold text-zinc-900">
                      {activeCount}
                    </span>
                    <span className="text-xs font-medium text-zinc-500">
                      / {planActiveLimit === 999 ? "∞" : planActiveLimit} max ({userPlan})
                    </span>
                  </div>
                </div>
                <div className="flex h-10 w-10 items-center justify-center rounded-[8px] bg-zinc-100 text-zinc-900">
                  <PlayCircle className="h-5 w-5" />
                </div>
              </div>
            </div>
          </section>

          {/* ClickUp / Asana Filter Header */}
          <section className="mb-6 rounded-[8px] border border-zinc-200 bg-white p-2.5 shadow-xs">
            <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
              
              {/* Filter Tabs */}
              <div className="flex flex-wrap items-center gap-1 rounded-[8px] bg-zinc-100 p-1">
                <div className="flex items-center px-2 text-zinc-400">
                  <SlidersHorizontal className="h-3.5 w-3.5" />
                </div>
                
                {filterOptions.map((filter) => {
                  const isActive = activeFilter === filter.value;
                  return (
                    <button
                      type="button"
                      key={filter.value}
                      onClick={() => setActiveFilter(filter.value)}
                      className={`group flex h-8 items-center gap-2 rounded-[8px] px-3 text-xs font-medium transition ${
                        isActive
                          ? "bg-white text-zinc-900 shadow-xs border border-zinc-200/80 font-semibold"
                          : "text-zinc-600 hover:bg-zinc-200/60 hover:text-zinc-900"
                      }`}
                    >
                      {isActive && <Check className="h-3 w-3 text-zinc-900" />}
                      <span>{filter.label}</span>
                      <span
                        className={`rounded-[8px] px-1.5 py-0.5 text-[10px] font-mono transition ${
                          isActive
                            ? "bg-zinc-900 text-white"
                            : "bg-zinc-200 text-zinc-600 group-hover:bg-zinc-300"
                        }`}
                      >
                        {filter.count}
                      </span>
                    </button>
                  );
                })}
              </div>

              {/* Search Control */}
              <div className="relative w-full lg:w-72">
                <Search className="absolute left-3 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-zinc-400" />
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(event) => setSearchQuery(event.target.value)}
                  placeholder="Filter scenarios..."
                  className="h-8 w-full rounded-[8px] border border-zinc-200 bg-zinc-50 pl-8 pr-4 text-xs text-zinc-900 outline-none transition placeholder:text-zinc-400 focus:border-zinc-900 focus:bg-white focus:ring-1 focus:ring-zinc-900"
                />
              </div>
            </div>
          </section>

          {/* Scenarios Table */}
          <section className="overflow-hidden rounded-[8px] border border-zinc-200 bg-white shadow-xs">
            <div className="hidden overflow-x-auto md:block">
              <table className="w-full text-left">
                <thead className="border-b border-zinc-200 bg-zinc-50">
                  <tr>
                    <th className="px-5 py-3 text-[11px] font-semibold uppercase  text-zinc-500">
                      Scenario Name
                    </th>
                    <th className="px-5 py-3 text-[11px] font-semibold uppercase  text-zinc-500">
                      Description
                    </th>
                    <th className="px-5 py-3 text-[11px] font-semibold uppercase  text-zinc-500">
                      Type
                    </th>
                    <th className="px-5 py-3 text-[11px] font-semibold uppercase  text-zinc-500">
                      Status
                    </th>
                    <th className="px-5 py-3 text-[11px] font-semibold uppercase  text-zinc-500">
                      Created
                    </th>
                    <th className="px-5 py-3 text-right text-[11px] font-semibold uppercase  text-zinc-500">
                      Actions
                    </th>
                  </tr>
                </thead>

                <tbody className="divide-y divide-zinc-100">
                  {loading && scenarios.length === 0 ? (
                    <tr>
                      <td colSpan={6} className="p-0">
                        <TableSkeleton rows={5} cols={6} />
                      </td>
                    </tr>
                  ) : filteredScenarios.length > 0 ? (
                    filteredScenarios.map((scenario) => (
                      <tr
                        key={scenario._id}
                        onClick={() => handleRowClick(scenario)}
                        className="group cursor-pointer transition hover:bg-zinc-50"
                      >
                        <td className="px-5 py-4">
                          <div className="flex items-center gap-3">
                            {/*
                              Live/paused at the very start of the row, so
                              the state of every scenario is scannable down
                              one column instead of read per row from the
                              Status cell further right.

                              Colour is not the only signal — the title
                              spells it out, and the Status badge still
                              carries the word.
                            */}
                            <StatusDot
                              tone={
                                scenario.scenarioActive
                                  ? "active"
                                  : scenarioBlockReason(scenario, connections)
                                    ? "paused"
                                    : "idle"
                              }
                              title={
                                scenario.scenarioActive
                                  ? "Active — this scenario is running"
                                  : scenarioBlockReason(scenario, connections)
                                    ? `Cannot activate — ${scenarioBlockReason(scenario, connections)}`
                                    : "Paused — this scenario will not reply"
                              }
                            />

                            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-[8px] border border-zinc-200 bg-zinc-50 group-hover:border-zinc-400 group-hover:bg-zinc-100">
                              {getScenarioIcon(scenario)}
                            </div>
                            <div className="min-w-0">
                              <p className=" text-sm font-semibold text-zinc-900 group-hover:text-black">
                                {getScenarioName(scenario)}
                              </p>
                              <p className="mt-0.5 text-[10px] font-heading text-zinc-400">
                                ID: {scenario._id?.slice(-8)}
                              </p>
                            </div>
                          </div>
                        </td>

                        <td className="max-w-xs px-5 py-4">
                          <p className="truncate text-xs text-zinc-600">
                            {getScenarioDescription(scenario)}
                          </p>
                        </td>

                        <td className="px-5 py-4">
                          <span className="inline-flex rounded-[8px] border border-zinc-200 bg-zinc-50 px-2.5 py-1 text-[10px] font-medium capitalize text-zinc-800">
                            {scenario.type || "Custom"}
                          </span>
                        </td>

                        <td className="px-5 py-4">
                          {(() => {
                            /*
                             * Only asked of a paused scenario. A running
                             * one has nothing to explain, and a scenario
                             * the user switched off on purpose has no
                             * fault to report either — blockReason is
                             * null for both.
                             */
                            const blockReason = scenario.scenarioActive
                              ? null
                              : scenarioBlockReason(scenario, connections);

                            return (
                              <>
                                <button
                                  type="button"
                                  onClick={(event) => handleToggleScenarioStatus(event, scenario)}
                                  className="cursor-pointer transition hover:scale-105 active:scale-95"
                                  title={
                                    blockReason
                                      ? `Cannot activate — ${blockReason}`
                                      : scenario.scenarioActive
                                        ? "Click to deactivate scenario"
                                        : "Click to activate scenario"
                                  }
                                >
                                  {scenario.scenarioActive ? (
                                    <span className="inline-flex items-center gap-1.5 rounded-[8px] border border-zinc-300 bg-zinc-900 px-2.5 py-1 text-[10px] font-medium text-white hover:bg-black">
                                      <span className="h-1.5 w-1.5 rounded-full bg-emerald-400 animate-pulse" />
                                      Active
                                    </span>
                                  ) : blockReason ? (
                                    <span className="inline-flex items-center gap-1.5 rounded-[8px] border border-red-200 bg-red-50 px-2.5 py-1 text-[10px] font-medium text-red-700 hover:bg-red-100">
                                      <span className="h-1.5 w-1.5 rounded-full bg-red-500" />
                                      Needs attention
                                    </span>
                                  ) : (
                                    <span className="inline-flex items-center gap-1.5 rounded-[8px] border border-zinc-200 bg-zinc-100 px-2.5 py-1 text-[10px] font-medium text-zinc-600 hover:bg-zinc-200">
                                      <span className="h-1.5 w-1.5 rounded-full bg-zinc-400" />
                                      Paused
                                    </span>
                                  )}
                                </button>

                                {blockReason && (
                                  <p className="mt-1 max-w-[220px] text-[10px] leading-snug text-red-600">
                                    {blockReason}
                                  </p>
                                )}
                              </>
                            );
                          })()}
                        </td>

                        <td className="whitespace-nowrap px-5 py-4 text-xs text-zinc-500">
                          {formatDate(scenario.createdAt)}
                        </td>

                        <td className="px-5 py-4">
                          <div className="flex items-center justify-end gap-1">
                            {scenario.type === "shopify" && shopifyCount <= 1 ? (
                              <div
                                className="flex h-8 w-8 items-center justify-center rounded-[8px] text-zinc-400 bg-zinc-100/70 cursor-not-allowed"
                                title="Primary Prebuilt System Scenario (Non-deletable)"
                              >
                                <Lock className="h-3.5 w-3.5 text-zinc-500" />
                              </div>
                            ) : (
                              <button
                                type="button"
                                onClick={(event) =>
                                  openDeleteModal(event, scenario)
                                }
                                className="flex h-8 w-8 items-center justify-center rounded-[8px] text-zinc-400 transition hover:bg-zinc-100 hover:text-zinc-900 cursor-pointer"
                                aria-label="Delete scenario"
                              >
                                <Trash2 className="h-4 w-4" />
                              </button>
                            )}
                            <ChevronRight className="h-4 w-4 text-zinc-300 transition group-hover:translate-x-0.5 group-hover:text-zinc-900" />
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={6}>
                        <div className="flex min-h-[220px] flex-col items-center justify-center p-8 text-center">
                          <div className="flex h-12 w-12 items-center justify-center rounded-[8px] bg-zinc-100 text-zinc-800">
                            <Workflow className="h-6 w-6" />
                          </div>
                          <h3 className="mt-3 text-sm font-semibold text-zinc-900">
                            No scenarios found
                          </h3>
                          <p className="mt-1 max-w-sm text-xs text-zinc-500">
                            No scenarios match your search or selected filter.
                          </p>
                          <button
                            type="button"
                            onClick={() => setShowSelectModal(true)}
                            className="mt-4 inline-flex h-8 items-center gap-1.5 rounded-[8px] bg-zinc-900 px-3 text-xs font-medium text-white transition hover:bg-zinc-800 cursor-pointer"
                          >
                            <Plus className="h-3.5 w-3.5" />
                            Create New Scenario
                          </button>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Mobile Cards */}
            <div className="divide-y divide-zinc-100 md:hidden">
              {loading ? (
                <div className="flex min-h-[180px] flex-col items-center justify-center p-6">
                  <span className="h-6 w-6 animate-spin rounded-full border-2 border-zinc-300 border-t-zinc-900" />
                  <p className="mt-3 text-xs font-medium text-zinc-500">
                    Loading scenarios...
                  </p>
                </div>
              ) : filteredScenarios.length > 0 ? (
                filteredScenarios.map((scenario) => (
                  <button
                    type="button"
                    key={scenario._id}
                    onClick={() => handleRowClick(scenario)}
                    className="w-full p-4 text-left transition hover:bg-zinc-50 active:bg-zinc-100"
                  >
                    <div className="flex items-start gap-3">
                      {/* Same live/paused light as the table view. */}
                      <StatusDot
                        tone={
                          scenario.scenarioActive
                            ? "active"
                            : scenarioBlockReason(scenario, connections)
                              ? "paused"
                              : "idle"
                        }
                        title={
                          scenario.scenarioActive
                            ? "Active — this scenario is running"
                            : scenarioBlockReason(scenario, connections)
                              ? `Cannot activate — ${scenarioBlockReason(scenario, connections)}`
                              : "Paused — this scenario will not reply"
                        }
                        className="mt-3.5"
                      />

                      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-[8px] border border-zinc-200 bg-zinc-50">
                        {getScenarioIcon(scenario)}
                      </div>

                      <div className="min-w-0 flex-1">
                        <div className="flex items-start justify-between gap-2">
                          <h3 className="truncate text-xs font-semibold text-zinc-900">
                            {getScenarioName(scenario)}
                          </h3>
                          <span
                            role="button"
                            tabIndex={0}
                            onClick={(event) =>
                              openDeleteModal(event, scenario)
                            }
                            onKeyDown={(event) => {
                              if (
                                event.key === "Enter" ||
                                event.key === " "
                              ) {
                                openDeleteModal(event, scenario);
                              }
                            }}
                            className="flex h-7 w-7 shrink-0 items-center justify-center rounded-[8px] text-zinc-400 hover:bg-zinc-100 hover:text-zinc-900"
                          >
                            <Trash2 className="h-3.5 w-3.5" />
                          </span>
                        </div>

                        <p className="mt-1 line-clamp-2 text-xs text-zinc-500">
                          {getScenarioDescription(scenario)}
                        </p>

                        <div className="mt-3 flex flex-wrap items-center gap-2">
                          <span className="rounded-[8px] border border-zinc-200 bg-zinc-50 px-2 py-0.5 text-[10px] font-medium capitalize text-zinc-800">
                            {scenario.type || "Custom"}
                          </span>

                          {scenario.scenarioActive ? (
                            <span className="inline-flex items-center gap-1 rounded-[8px] bg-zinc-900 px-2 py-0.5 text-[10px] font-medium text-white">
                              <PlayCircle className="h-3 w-3 text-zinc-300" />
                              Active
                            </span>
                          ) : scenarioBlockReason(scenario, connections) ? (
                            <span className="inline-flex items-center gap-1 rounded-[8px] border border-red-200 bg-red-50 px-2 py-0.5 text-[10px] font-medium text-red-700">
                              <PauseCircle className="h-3 w-3 text-red-500" />
                              Needs attention
                            </span>
                          ) : (
                            <span className="inline-flex items-center gap-1 rounded-[8px] border border-zinc-200 bg-zinc-100 px-2 py-0.5 text-[10px] font-medium text-zinc-600">
                              <PauseCircle className="h-3 w-3 text-zinc-400" />
                              Paused
                            </span>
                          )}

                          <span className="text-[10px] text-zinc-400">
                            {formatDate(scenario.createdAt)}
                          </span>
                        </div>

                        {!scenario.scenarioActive &&
                          scenarioBlockReason(scenario, connections) && (
                            <p className="mt-1.5 text-[10px] leading-snug text-red-600">
                              {scenarioBlockReason(scenario, connections)}
                            </p>
                          )}
                      </div>
                    </div>
                  </button>
                ))
              ) : (
                <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
                  <Workflow className="h-8 w-8 text-zinc-300" />
                  <h3 className="mt-3 text-sm font-semibold text-zinc-900">
                    No scenarios found
                  </h3>
                  <p className="mt-1 text-xs text-zinc-500">
                    Try adjusting your search query or reset filters.
                  </p>
                </div>
              )}
            </div>
          </section>
        </div>

      {/* Delete Confirmation Modal */}
      {deleteModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 px-4 backdrop-blur-sm">
          <div className="w-full max-w-md rounded-[8px] border border-zinc-200 bg-white p-6 shadow-xl">
            <div className="flex items-start justify-between">
              <div className="flex h-10 w-10 items-center justify-center rounded-[8px] bg-zinc-100 text-zinc-900">
                <Trash2 className="h-5 w-5" />
              </div>
              <button
                type="button"
                onClick={() => {
                  setDeleteModalOpen(false);
                  setSelectedScenario(null);
                }}
                className="flex h-8 w-8 items-center justify-center rounded-[8px] text-zinc-400 hover:bg-zinc-100 hover:text-zinc-700"
              >
                <X className="h-4 w-4" />
              </button>
            </div>

            <h2 className="mt-4 text-base font-semibold text-zinc-900">
              Delete Scenario?
            </h2>

            <p className="mt-1.5 text-xs leading-relaxed text-zinc-500">
              Are you sure you want to permanently delete{" "}
              <span className="font-semibold text-zinc-900">
                "{selectedScenario ? getScenarioName(selectedScenario) : "this scenario"}"
              </span>
              ? This action cannot be undone.
            </p>

            <div className="mt-6 flex items-center justify-end gap-2">
              <button
                type="button"
                onClick={() => {
                  setDeleteModalOpen(false);
                  setSelectedScenario(null);
                }}
                className="h-9 rounded-[8px] border border-zinc-200 bg-white px-4 text-xs font-semibold text-zinc-700 transition hover:bg-zinc-50"
              >
                Cancel
              </button>

              <button
                type="button"
                onClick={handleDelete}
                className="h-9 rounded-[8px] bg-zinc-900 px-4 text-xs font-semibold text-white transition hover:bg-black shadow-xs"
              >
                Delete Scenario
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Upgrade Modal */}
      {upgradeModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 px-4 backdrop-blur-sm">
          <div className="relative w-full max-w-md rounded-[12px] border border-zinc-200 bg-white p-6 shadow-2xl animate-in zoom-in-95 duration-150">
            <button
              type="button"
              onClick={() => setUpgradeModalOpen(false)}
              className="absolute right-4 top-4 flex h-8 w-8 items-center justify-center rounded-[8px] text-zinc-400 hover:bg-zinc-100 hover:text-zinc-700"
            >
              <X className="h-4 w-4" />
            </button>

            <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-amber-50 border border-amber-200 text-amber-700">
              <AlertTriangle className="h-5 w-5" />
            </div>

            <h2 className="mt-4 text-lg font-bold text-zinc-950">
              Active Scenario Limit Reached
            </h2>

            <p className="mt-2 text-xs leading-relaxed text-zinc-600">
              Your account is currently on the <strong className="text-zinc-900">{userPlan}</strong> plan, which allows up to <strong className="text-zinc-900">{planActiveLimit} active scenario{planActiveLimit > 1 ? "s" : ""}</strong> simultaneously ({activeCount} currently active).
            </p>

            <div className="mt-4 rounded-xl border border-amber-200 bg-amber-50/60 p-4">
              <div className="flex items-center gap-1.5 text-xs font-bold text-amber-950">
                <Sparkles className="h-4 w-4 text-amber-600" />
                Why activation is blocked
              </div>
              <p className="mt-1 text-xs leading-relaxed text-amber-900">
                To activate <strong className="text-zinc-950">{selectedScenario?.name || "this scenario"}</strong>, please deactivate an existing active scenario or upgrade your plan to unlock higher concurrent automation limits.
              </p>
            </div>

            <div className="mt-6 flex items-center justify-end gap-2.5 border-t border-zinc-100 pt-4">
              <button
                type="button"
                onClick={() => setUpgradeModalOpen(false)}
                className="h-9 rounded-lg border border-zinc-300 bg-white px-4 text-xs font-semibold text-zinc-700 hover:bg-zinc-50 transition cursor-pointer"
              >
                Keep Current Scenarios
              </button>
              <button
                type="button"
                onClick={() => {
                  setUpgradeModalOpen(false);
                  navigate("/pricing");
                }}
                className="h-9 rounded-lg bg-zinc-900 px-4 text-xs font-bold text-white transition hover:bg-black shadow-xs cursor-pointer"
              >
                Upgrade Plan
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Scenario Select Modal */}
      <ScenarioSelectModal
        open={showSelectModal}
        onClose={() => setShowSelectModal(false)}
      />
      </div>
    </AppLayout>
  );
};

export default AllScenariosPage;
